"use client";

import { ReactNode, useEffect, useState } from "react";
import { TooltipProvider as UITooltipProvider } from "@/components/ui/tooltip";

export function TooltipProvider({ children }: { children: ReactNode }) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Don't render tooltips during SSR
  if (!isMounted) {
    return <>{children}</>;
  }

  return <UITooltipProvider>{children}</UITooltipProvider>;
} 